/**
 * Source unique des tuiles de fond de carte (Leaflet).
 *
 * Historique : on utilisait CARTO Basemaps (style « Positron »), qui a fermé son
 * accès anonyme — les tuiles revenaient filigranées « API KEY REQUIRED ».
 *
 * On sert désormais les tuiles officielles de l'OpenStreetMap Foundation :
 * gratuites, sans clé, sans compte. Attention : leur tile usage policy
 * (https://operations.osmfoundation.org/policies/tiles/) exclut les usages
 * commerciaux soutenus et l'OSMF peut throttler sans préavis. C'est un
 * dépannage, pas une cible pérenne — la suite est de passer à un fournisseur
 * avec clé (Stadia Maps « Alidade Smooth », visuellement proche de Positron,
 * ou MapTiler), ce qui ne demande que de changer les deux constantes ci-dessous.
 *
 * Format de l'URL : pas de placeholder `{s}` (l'OSM n'utilise plus les
 * sous-domaines a/b/c) ni `{r}` (pas de tuiles retina) — les laisser produirait
 * des 404 systématiques.
 */
export const MAP_TILE_URL = 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';

/** Attribution obligatoire pour les tuiles OSM. */
export const MAP_TILE_ATTRIBUTION = '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
